module.exports = __webpack_public_path__ + "media/images/icon_empty-a0adccdf61d1f966bce502cc5ffa7863.svg";